/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutorial_VideosInputs */

const en_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial Videos`)
};

const fr_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéos tutoriels`)
};

const de_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial-Videos`)
};

const it_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video tutorial`)
};

const ru_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеоуроки`)
};

const es_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeos tutoriales`)
};

const zh_cn2_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教程视频`)
};

const ja_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チュートリアルビデオ`)
};

const hi_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्यूटोरियल वीडियो`)
};

const pt_pt2_tutorial_videos = /** @type {(inputs: Tutorial_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeos tutoriais`)
};

/**
* | output |
* | --- |
* | "Tutorial Videos" |
*
* @param {Tutorial_VideosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tutorial_videos = /** @type {((inputs?: Tutorial_VideosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutorial_VideosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tutorial_videos(inputs)
	if (locale === "de") return de_tutorial_videos(inputs)
	if (locale === "it") return it_tutorial_videos(inputs)
	if (locale === "ru") return ru_tutorial_videos(inputs)
	if (locale === "es") return es_tutorial_videos(inputs)
	if (locale === "zh-CN") return zh_cn2_tutorial_videos(inputs)
	if (locale === "ja") return ja_tutorial_videos(inputs)
	if (locale === "hi") return hi_tutorial_videos(inputs)
	if (locale === "pt-PT") return pt_pt2_tutorial_videos(inputs)
	return en_tutorial_videos(inputs)
});